export default "__VITE_ASSET__Bi0vINes__"